export default __webpack_public_path__ + "static/media/product20_sportshoe.320e0d2c.webp";